class NumericoForm {
    numerico = {
      value: '',
      required: false,
      state: null
    }
}

class NumericoData {
    numerico = null
}

export { NumericoForm, NumericoData }



// WEBPACK FOOTER //
// ./src/views/private/configurations/person/components/add/numerico-form.js